import { PRODUCT_IDS_WITH_LOW_PRICES_FOR_AQA } from 'constants/product';
import { DAYS_PER_YEAR } from 'constants/periods';
import { PaymentMethods } from 'constants/payment';

import { isMainSubscription } from 'helpers/subscriptions';

import { CancellationFlow } from 'components/Modals/CancellationReasonModal/types';

import { ISubscription, PaymentProviders } from 'types/subscription';
import { SubscriptionProductCodeTypes } from 'types/product';

export const isPauseFlow = ({
    flow,
    productCodeType,
    wasPaused,
}: {
    flow: string;
    productCodeType: SubscriptionProductCodeTypes;
    wasPaused: boolean;
}) => {
    if (wasPaused) return false;

    const isPauseSubscriptionFlow = flow === CancellationFlow.withPauseSubscription;
    const isMainPlanSubscription = isMainSubscription(productCodeType);

    return isPauseSubscriptionFlow && isMainPlanSubscription;
};

export const isOneYearSubscription = (period: number): boolean => {
    return period === DAYS_PER_YEAR;
};

export const checkIsProductIdWithTestPrice = (productId: string): boolean => {
    return PRODUCT_IDS_WITH_LOW_PRICES_FOR_AQA.includes(productId);
};

export const checkIsPaymentFormNeeded = (candidate: ISubscription) => {
    return (
        candidate.payment_provider === PaymentProviders.Solidgate &&
        [PaymentMethods.google_pay, PaymentMethods.apple_pay].includes(candidate.payment_method)
    );
};
